import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';
import { Glyphicon, Button } from 'react-bootstrap';
import { DataTable, ItemAction, ContentMessage } from 'axway-react-ui';

class JoinsList extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
	}

	render() {
		const { className, emptyMessage, joins, onAdd, onAddEnabled,
			onEdit, onDelete, editable } = this.props;

		const mergeTypeStr = {
			array: this.intl.formatMsg('Array'),
			fields: this.intl.formatMsg('Fields'),
			object: this.intl.formatMsg('Object')
		};

		const rows = joins.map(join => {
			return {
				condition: `${join.modelName}.${join.fieldName} = ${join.model}.${join.field}`,
				joinType: (join.type === 'inner_join')
					? this.intl.formatMsg('Inner join (matching rows)')
					: this.intl.formatMsg('Left join (all rows)'),
				mergeType: mergeTypeStr[join.merge],
				_actions_: editable ? (
					<div>
						<ItemAction
							key="item-edit"
							item={join}
							onAction={onEdit}
							className="edit"
							tooltip={this.intl.formatMsg('Modify the applied join')}
							tooltipPlacement="left"
							icon="pencil"
						/>
						<ItemAction
							key="item-delete"
							item={join}
							onAction={onDelete}
							className="delete"
							tooltip={this.intl.formatMsg('Delete the applied join')}
							tooltipPlacement="left"
							icon="trash2"
						/>
					</div>
				) : undefined
			};
		});

		const columns = [
			{
				key: 'condition',
				className: 'condition',
				name: this.intl.formatMsg('Join Condition')
			},
			{
				key: 'joinType',
				className: 'joinType',
				name: this.intl.formatMsg('Join Type')
			},
			{
				key: 'mergeType',
				className: 'mergeType',
				name: this.intl.formatMsg('Merge Type')
			}
		];

		if (editable) {
			columns.push({
				key: '_actions_',
				className: 'actions'
			});
		}

		return (
			<div className="joins-list">
				<div className="join-info-container">
					<div className="legend ux-type-size-two">
						{
							// Joins are used to connect the parent data source to other
							// sources using corresponding fields.
							this.intl.formatMsg('Joins')
						}
					</div>
					{onAdd && (
						<span className="action">
							<Button
								bsSize="large"
								className={onAddEnabled ? 'compact create' : 'compact create disabled'}
								onClick={() => onAddEnabled && onAdd()}
							>
								<Glyphicon glyph=" gg icon-GG-link" />
								{ this.intl.formatMsg('Join') }
							</Button>
						</span>
					)}
				</div>
				{(!rows || !rows.length) && emptyMessage && (
					<ContentMessage
						title={this.intl.formatMsg('No model joins')}
						detail={emptyMessage}
						imgClass="gg icon-GG-empty-list"
						className={`sm empty ${className}`}
						inlineContent
					/>
				)}
				{rows && !!rows.length && (
					<DataTable
						className={`joins-list sub-table ${className}`}
						striped
						columns={columns}
						items={rows}
					/>
				)}
			</div>
		);
	}
}

JoinsList.propTypes = {
	/** Class name to apply to component. */
	className: PropTypes.string,

	/** if the joins can be edited */
	editable: PropTypes.bool,

	/** the joins data to be displayed in the table */
	joins: PropTypes.arrayOf(
		PropTypes.shape({

			/** the first model to start the join with */
			modelName: PropTypes.string,

			/** the first model's field to start join with' */
			fieldName: PropTypes.string,

			/** second model that is joined to the first one */
			model: PropTypes.string,

			/** second model's field join is based upon */
			field: PropTypes.string,

			/** join type (inner_join/left_join). The '_' will be replaced by ' ' */
			type: PropTypes.string,

			/** merge type (object, array, fields) */
			merge: PropTypes.string
		})
	).isRequired,

	/**
	* Called when the top-level add join button is clicked.
	*/
	onAdd: PropTypes.func,

	/**
	* Flag to indicate if the add button is enabled.
	*/
	onAddEnabled: PropTypes.bool,

	/** called on 'edit' icon clicked receiving clicked item as an argument.
	 *  The item is a child of 'joins' array.
	*/
	onEdit: PropTypes.func,

	/** called on 'delete' icon clicked receiving clicked item as an argument.
	 *  The item is a child of 'joins' array.
	*/
	onDelete: PropTypes.func
};

JoinsList.defaultProps = {
	onAddEnabled: true
};

export default injectIntl(JoinsList);
